import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=5b2910d3&scoped=true&"
import script from "./CollapsePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=5b2910d3&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2910d3",
  null
  
)

export default component.exports